module.exports = __webpack_public_path__ + "img/NL336.9c5d77dd.png";